import { type FunctionComponent, useCallback } from 'react';
import { VStack } from '@direct-frontend/components';
import { Drawer, DrawerBottomFixed, DrawerButton, DrawerHeader } from '@/shared/components/Drawer';
import { ServiceTypeIcon } from '@/shared/components/ServiceTypeIcon';
import { Slot } from '@/shared/components/Slot';
import { type PickupAddressValue } from '../../types/PickupAddressValue';
import styles from './PickupSavedAddressesDialog.module.css';

interface PickupSavedAddressesDialogProps {
    isOpen: boolean;
    items: PickupAddressValue[];
    onClose: VoidFunction;
    onAddAddress: VoidFunction;
    onChange?: (value: PickupAddressValue) => void;
}

export const PickupSavedAddressesDialog: FunctionComponent<PickupSavedAddressesDialogProps> = (props) => {
    const { isOpen, items, onAddAddress, onChange, onClose } = props;

    const handleChange = useCallback(
        (value: PickupAddressValue) => {
            onChange?.(value);
            onClose();
        },
        [onChange, onClose]
    );

    if (items.length === 0) {
        return null;
    }

    return (
        <Drawer isOpen={isOpen} onClose={onClose}>
            <VStack className={styles.modal}>
                <VStack className={styles.container}>
                    <DrawerHeader title="Пункты выдачи" className={styles.title} />
                    <VStack className={styles.list}>
                        {items.map((address, index) => (
                            <div
                                key={address.pickupPointId}
                                className={styles.item}
                                onClick={() => handleChange(address)}
                            >
                                <Slot
                                    title={address.address}
                                    subtitle={address.locality}
                                    border={index < items.length - 1}
                                    icon={<ServiceTypeIcon serviceType={address.serviceType} size="24" />}
                                />
                            </div>
                        ))}
                    </VStack>
                </VStack>

                <DrawerBottomFixed>
                    <DrawerButton onClick={onAddAddress}>Выбрать новый</DrawerButton>
                </DrawerBottomFixed>
            </VStack>
        </Drawer>
    );
};
